const EnvironmentNames = {
  LOCALHOST: "localhost",
  DEV: "dev",
  LIVE: "live"
};

export default EnvironmentNames;
